import { render, staticRenderFns } from "./PortfoliosOverviewSummary.vue?vue&type=template&id=166dc74a&scoped=true&"
import script from "./PortfoliosOverviewSummary.vue?vue&type=script&lang=js&"
export * from "./PortfoliosOverviewSummary.vue?vue&type=script&lang=js&"
import style0 from "./PortfoliosOverviewSummary.vue?vue&type=style&index=0&id=166dc74a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "166dc74a",
  null
  
)

export default component.exports